import { useEffect } from "react";
import { useNavigation } from "react-router";
import { BProgress } from "@bprogress/core";

export default function TopBar() {
  const navigation = useNavigation();
  BProgress.configure({ showSpinner: false });

  useEffect(() => {
    if (navigation.state === "loading") {
      BProgress.start(); // Start progress bar
    } else {
      BProgress.done(); // Complete progress bar
    }
  }, [navigation.state]);

  return null; // No visual component needed
}
